import React, { useEffect, useState } from 'react'
import PageContainer from 'src/components/container/PageContainer'
import FieldData from './FieldData'
import { Box, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { useMain } from '../hooks/useMain'
import ShowLoader from 'src/components/CustomComponents/ShowLoader'
import DashboardCard2 from 'src/components/shared/DashboardCard2'
import { Search } from '@mui/icons-material'

const data = [
    {
        id: 1,
        dateOfBill: '2023-06-01',
        billId: 'B001',
        clientName: 'John Doe',
        contact: '1234567890',
        total: 150,
        paid: 100,
        paymentDetail: 'Paid via credit card',
        pending: 50,
        type: 'Service',
        serviceProduct: 'Massage',
        serviceProvider: 'Jane Smith',
    },
    {
        id: 2,
        dateOfBill: '2023-06-03',
        billId: 'B002',
        clientName: 'Jane Smith',
        contact: '9876543210',
        total: 200,
        paid: 200,
        paymentDetail: 'Paid via cash',
        pending: 0,
        type: 'Product',
        serviceProduct: 'Facial Cream',
        serviceProvider: '',
    },
    // Add more objects here
];


const AllBillings = () => {
    const [data, setData] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [activePage, setActivePage] = useState(1);
    const [showLoader, setShowLoader] = useState(false);

    const { fetchAllBillings } = useMain();

    const getData = async () => {
        setShowLoader(true);
        const res = await fetchAllBillings({ limit: 10, page: activePage });
       
        setData(res?.data?.result);
        setTotalPage(res?.data?.totalPage)
        setShowLoader(false);
    }

    useEffect(() => {
        getData();

        return () => { }
    }, []);

    return (
        <PageContainer title="Billing History" description="this contains all products">
            <DashboardCard2 title="Billing History">
                <Grid container spacing={2} sx={{ mt: 1, mb: 3 }} alignItems="center">
                    <Grid item xs={6}>
                        <FormControl variant="standard" style={{ minWidth: 120 }}>
                            <InputLabel>Show per page</InputLabel>
                            <Select value={10} onChange={() => { }}>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} container justifyContent="flex-end">
                        <TextField
                            label="Search"
                            variant="standard"
                            fullWidth
                            style={{
                                maxWidth: '300px'
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Search />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
                <Box>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={12}>
                            <FieldData data={data} />
                        </Grid>
                    </Grid>
                </Box>
                {/* {showLoader && <ShowLoader value={showLoader} />} */}
            </DashboardCard2>
        </PageContainer>
    )
}

export default AllBillings